import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetEcshopTradesRequestModel, GetEcshopTradesResponseModel } from "@/features/accounts/ecshop/services/get-trades-model";

export class GetEcshopTradesApi {
  /**
   * その他連携明細取得API
   */
  public getEcshopTrades = async (
    param: GetEcshopTradesRequestModel
  ): Promise<GetEcshopTradesResponseModel[]> => {
    const path = `/api/ecshopaccounts/ecshops/trades`;
    const res = await ApiClient.instance.get<GetEcshopTradesResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
